import DOMReady from './utils/DOMReady'
import form from './modules/form'
import formUnderlined from './modules/form-underlined'
import authForm from './modules/auth-form'
import logout from './modules/logout'
import imageField from './modules/image-field'
import header from './modules/header'
import lazyLoad from './modules/lazy-load'
import loadMore from './modules/load-more'
import modal from './modules/modal'
import bookmark from './modules/bookmark'
import bookmarks from './modules/bookmarks'
import multiselect from './modules/multiselect'
import passwordField from './modules/password-field'
import scrollToSection from './modules/scroll-to-section'
import svgLoader from './modules/svg-loader'
import tabs from './modules/tabs'
import developerSearch from './react/developer-search'

// Include css for webpack (for development only)
const css = require('../css/main.scss') // eslint-disable-line no-unused-vars

// Set CSP for 1st party scripts
if (window.trustedTypes && window.trustedTypes.createPolicy) {
  window.trustedTypes.createPolicy('default', {
    // eslint-disable-next-line no-unused-vars
    createHTML: (string, sink) => string,
  })
}

DOMReady(() => {
  form.init()
  formUnderlined.init()
  authForm.init()
  logout.init()
  imageField.init()
  header.init()
  lazyLoad.init()
  loadMore.init()
  modal.init()
  bookmark.init()
  bookmarks.init()
  multiselect.init()
  passwordField.init()
  scrollToSection.init()
  svgLoader.init()
  tabs.init()
  developerSearch.init()
})
